import {UserStripeService} from "../../../stripe/service/UserStripeService";
import {StripeProductName} from "../../../stripe/models/StripeProductNames";
import {IHttpService} from "angular";
import {StoreProductStates} from "../../common/models/StoreProductState";
import {StoreService} from "../../common/services/StoreService";
import {TfProductMappings, TfStoreProduct} from "../models/TfStoreProduct";

export class TfStoreService extends StoreService<TfStoreProduct> {

    public static id = "tfStoreService";

    protected updateUrl = "/tradefloor/api/store/tf/subscriptions";

    /** @ngInject */
    public constructor($http: IHttpService, userStripeService: UserStripeService) {
        super($http, userStripeService);
    }

    public async currentProductState(): Promise<StoreProductStates<TfStoreProduct>> {
        const [history, subscriptions] = await this.userDetails();
        const testProductHistory = history.historyFor(StripeProductName.TRADEFLOOR_PRO);
        const hasTestProductSubscription = this.hasSubscriptionFor(subscriptions, TfProductMappings.TRADEFLOOR_PRO.stripeProducts);
        const product = this.productState(hasTestProductSubscription, testProductHistory);
        return {
            TRADEFLOOR_PRO: product
        };
    }
}
